import type { Term, TermType } from "@onestore/api/types"

export function getTermsByType(
  type: TermType,
  terms: Term[],
  activeTermTabId: number
): Term["id"][] {
  return terms
    .filter((term) => {
      return term.checked[activeTermTabId] && term.type === type
    })
    .map((term) => term.id)
}
